import instance from "../components/general/AxiosInterceptor";

export const creationNouveauPackageApi = (data) => {
  console.log(JSON.stringify(data));
  return instance.post("/packages", data);
};

export const modificationPackageApi = ({ packageId, data }) => {
  console.log(JSON.stringify(data));
  return instance.patch(`/packages/update/${packageId}`, data);
};

export const getConsultationPackagesListApi = (data) => {
  return instance.post("/packages/search", data);
};

export const getHistoriquePackageApi = (packageId) => {
  return instance.get(`/packages/historique/${packageId}`);
};

export const getPackageApi = (packageId) => {
  return instance.get(`/packages/${packageId}`);
};

export const deletePackageApi = (packageId) => {
  return instance.delete(`/packages/${packageId}`);
};

export const excelExportPackagesApi = (data) => {
  return instance.post("/packages/exporter", data);
};
